<template>
<div>
    <div class="container animated fadeIn">        
        <div class="row">            
            <div class="col-md-4 vessel">
                <VesselsInfoComponent :vessel="vessel" />
            </div>            
            <div class="col-md-8 align-column-unbilled">
                <UnbilledComponent :unbilled="vessel" />
                <TableComponent :data="invoices" />
            </div>
        </div>
    </div>
</div> 
</template>

<script>

// Service
import * as vesselservice from '../services/vessels_service'

// Components
import UnbilledComponent from "../components/UnbilledComponent.vue"
import VesselsInfoComponent from "../components/VesselsInfoComponent.vue"
import TableComponent from "../components/TableComponent.vue"

export default {
    name:"dashboard",
    components:{
        UnbilledComponent,
        VesselsInfoComponent,  
        TableComponent      
    },

    data() {
        return {          
            vessel: {},
            invoices: []
        }
    },
   
    mounted() {         
        this.getVesselsByUserId();

        setInterval(() => {
            this.getVesselsByUserId();
        }, 60000);
    },

    methods: {
        
        async getVesselsByUserId() {
            const user = localStorage.getItem('user');
            const userData = JSON.parse(user);
            const userId = userData.kp_user_id;
            const id = { kf_user_id: userId }

            try {
                const response = await vesselservice.getVesselByUserId(id);
                                
                if(response.status === 200) {
                    this.vessel = response.data[0];
                    this.invoices = response.data[0].invoices;
                }
                
            } catch (error) {
                console.log(error);
            }          
        },
     
    },
}
</script>